import { isLeYou } from './utils'

const SERVER_ENV = process.env.VUE_APP_SEVERENV

const host_beta = {
  popManage: '//test.popmanage.haiziwang.com',
  score: '//test.bsm.haiziwang.com',
  bcomment: '//bcomment.haiziwang.com',
  cms: '//cms.haiziwang.com',
  mapi: isLeYou ? '//mapi.leyou.com' : 'https://mapi.haiziwang.com',
  seller: '//test.pop.haiziwang.com',
  portal: isLeYou ? '//portal.leyou.com' : '//portal.haiziwang.com',
  partner: '//test.partner.haiziwang.com',
  scm: '//test.scm.haiziwang.com',
  zhs: '//zhsapi.haiziwang.com',
  hbpsupplier: '//test.hbpsupplier.haiziwang.com',
  ms: '//test.ms.haiziwang.com',
  hbpproduct: '//test.hbpproduct.haiziwang.com',
  collection: '//collection.haiziwang.com',
  ksds: '//testkskds.haiziwang.com',
  hbprewardpunish: '//hbprewardpunish.haiziwang.com',
  hbpnotice: '//hbpnotice.haiziwang.com',
  hbpcollege: '//test.hbpcollege.haiziwang.com',
  hbpworkbench: '//hbpworkbench.haiziwang.com', //统一待办
  msgbox: '//msgbox.haiziwang.com',
  businessMainInfo: '//test.businessbaseapi.haiziwang.com', // 查商家主数据
  dataadvice: '//dataadvice.haiziwang.com',
  hbpsproxyapi: '//test.hbpsproxy.haiziwang.com',
  bh: '//bh.haiziwang.com'
}

const host_idc = {
  popManage: '//popmanage.haiziwang.com',
  // score: '//bsm.haiziwang.com', //域名不通 换下面移动端域名 (通用)
  score: '//bscorem.haiziwang.com',
  bcomment: '//bcomment.haiziwang.com',
  cms: '//cms.haiziwang.com',
  mapi: isLeYou ? '//mapi.leyou.com' : 'https://mapi.haiziwang.com',
  seller: '//seller.haiziwang.com',
  portal: isLeYou ? '//portal.leyou.com' : '//portal.haiziwang.com',
  partner: '//partner.haiziwang.com',
  scm: '//partnerstencent.haiziwang.com',
  zhs: '//zhsapi.haiziwang.com',
  hbpsupplier: '//hbpsupplier.haiziwang.com',
  ms: '//msapi.haiziwang.com',
  hbpproduct: 'https://hbpproduct.haiziwang.com',
  collection: '//collection.haiziwang.com',
  ksds: '//kskds.haiziwang.com',
  hbprewardpunish: '//hbprewardpunish.haiziwang.com',
  hbpnotice: '//hbpnotice.haiziwang.com',
  hbpcollege: '//hbpcollege.haiziwang.com',
  hbpworkbench: '//hbpworkbench.haiziwang.com',
  msgbox: '//msgbox.haiziwang.com',
  businessMainInfo: '//businessapi.haiziwang.com',
  dataadvice: '//dataadvice.haiziwang.com',
  hbpsproxyapi: '//hbpsproxy.haiziwang.com',
  bh: '//bh.haiziwang.com'
}

const host = SERVER_ENV === 'BETA' ? host_beta : host_idc

export default host
